// extracted by mini-css-extract-plugin
export default {"colors":"\"../styles/colors.css\"","primaryColor":"#3A237B","label":"PasswordConfirmation_label__FEs6l","submitButton":"PasswordConfirmation_submitButton__h+D1g"};